'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Icon from "material-ui-icons/SettingsOverscan";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Login = (_temp = _class = function (_EditorComponent) {
  _inherits(Login, _EditorComponent);

  function Login() {
    _classCallCheck(this, Login);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  Login.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'Login'));
  };

  Login.prototype.renderChildren = function renderChildren() {
    var user = this.context.user;
    return user ? this.renderAuthorized() : this.renderUnauthorized();
  };

  Login.prototype.renderAuthorized = function renderAuthorized() {
    var _this2 = this;

    var _context = this.context,
        user = _context.user,
        Grid = _context.Grid,
        Link = _context.Link,
        UserLink = _context.UserLink;
    var userId = user.id,
        username = user.username,
        fullname = user.fullname;
    return _react2.default.createElement(Grid, {
      container: true,
      alignItems: 'center'
    }, _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(UserLink, {
      user: user,
      style: {
        marginLeft: 5
      },
      variant: null
    }, _react2.default.createElement(_Typography2.default, {
      color: 'inherit'
    }, fullname || username))), _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(_Button2.default, {
      onClick: function onClick() {
        return _this2.logout();
      },
      color: 'inherit'
    }, this.lexicon("Signout"))));
  };

  Login.prototype.renderUnauthorized = function renderUnauthorized() {
    var _this3 = this;

    return _react2.default.createElement(_Button2.default, {
      onClick: function onClick(e) {
        // this.setState({
        //   opened: true,
        // });
        var openLoginForm = _this3.context.openLoginForm;
        openLoginForm();
      },
      color: 'inherit'
    }, this.lexicon("Signin"));
  };

  Login.prototype.logout = function logout() {
    var logout = this.context.logout;
    logout();
  };

  return Login;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _class.Name = "Login", _temp);
exports.default = Login;
module.exports = exports['default'];